/**
 * Weapon Registry — central registration and lookup for all weapon definitions.
 */

import type { Projectile } from '../types';
import type { Rarity, WeaponDef } from './types';

// ─── Weapon Registry ─────────────────────────────────────────────────────────

const WEAPON_REGISTRY: Record<string, WeaponDef> = {};

export function registerWeapon(w: WeaponDef): WeaponDef {
  WEAPON_REGISTRY[w.id] = w;
  return w;
}

export function lookupWeapon(id: string): WeaponDef {
  return WEAPON_REGISTRY[id] ?? WEAPON_REGISTRY['mortar'];
}

export function getWeaponsByRarity(rarity: Rarity): WeaponDef[] {
  return Object.values(WEAPON_REGISTRY).filter(w => w.rarity === rarity && w.id !== 'mortar' && w.tier !== 'SUB');
}

// ─── Projectile Factory ──────────────────────────────────────────────────────

let _nextId = 1;

export function createProjectile(
  weapon: WeaponDef,
  x: number, y: number,
  vx: number, vy: number,
  firedBy: number,
  frameCount: number,
  generation: number = 0,
): Projectile {
  return {
    id: _nextId++,
    x, y, vx, vy,
    radius: weapon.projectileRadius,
    color: weapon.color,
    trail: [],
    owner: firedBy,
    weapon,
    bouncesRemaining: weapon.bounces,
    behaviorState: {},
    ignoreTerrain: false,
    ignoreTanks: false,
    ignoreWind: false,
    spawnFrame: frameCount,
    generation,
  };
}

// ─── Default Weapon ──────────────────────────────────────────────────────────

export function getDefaultWeapon(): WeaponDef {
  return WEAPON_REGISTRY['mortar'];
}
